import Icon from '../../../components/Icon/Icon';

const ForgotPasswordModal = () => (
  <div className="modal-content">
    <span className="modal-status-icon modal-status-icon--success"><Icon name="mail" /></span>
    <h1 id="modal-title" className="modal-title">Correo enviado</h1>
    <p className="modal-text">Revisa tu correo institucional para continuar con la recuperación de tu contraseña.</p>
  </div>
);

export default ForgotPasswordModal;
